<template>
  <div>
    <v-container fluid grid-list-md class="padding_10">
      <!--            <v-layout class="index_header">-->
      <!--                <v-flex xs12 md4 justify-space-around>-->
      <!--                    <v-autocomplete-->
      <!--                        v-model="filters.number"-->
      <!--                        :items="number_list"-->
      <!--                        prepend-icon="mdi-database-search"-->
      <!--                        placeholder="Search By Train Number"-->
      <!--                        :search-input.sync="search_number"-->
      <!--                        item-value="number"-->
      <!--                        item-text="number"-->
      <!--                        clearable-->
      <!--                        @change="searchByNumber()"-->
      <!--                    ></v-autocomplete>-->
      <!--                </v-flex>-->

      <!--            </v-layout>-->
      <v-expansion-panel class="mb-4">
        <v-expansion-panel-content>
          <template v-slot:header>
            <div>Filters</div>
          </template>
          <v-layout row wrap style="padding: 0px 10px 0px 10px; align-content: center;">
            <v-flex sm12 md6 lg2>
              <v-autocomplete
                  solo flat
                  v-model="filters.lines"
                  :loading="loading.lines"
                  :items="lines"
                  multiple
                  item-text="name"
                  item-value="id"
                  label="Line"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm12 md6 lg2>
              <v-text-field
                  solo flat
                  v-model="filters.number"
                  label="Number"
              ></v-text-field>
            </v-flex>
            <v-flex sm12 md6 lg3>
              <v-autocomplete
                  solo flat
                  v-model="filters.status"
                  :items="train_statuses"
                  multiple
                  item-text="text"
                  item-value="value"
                  label="Status"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm12 md6 lg3>
              <v-menu
                  v-model="filterDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="filters.date"
                      label="Date"
                      readonly
                      v-bind="attrs"
                      v-on="on"  solo flat
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="filters.date"
                    @input="filterDateMenu = false"
                    :min=minDate
                    :max=currentDate
                ></v-date-picker> 
              </v-menu>
            </v-flex>
            <v-flex sm12 md12 lg2 style="display: flex; justify-content: center; margin-top: -17px;">
              <v-btn @click="applyFilters" color="primary" class="mt-3">
                Filter
              </v-btn>
            </v-flex>
          </v-layout>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12>
          <v-data-table
              no-results-text="Loading... Please wait"
              :headers="headers"
              :items="train_list"
              item-key="id"
              :loading="loaders.train_list"
              :pagination.sync="pagination"
              :total-items="total_items"
              :rows-per-page-items="[10, 20, 50, 100]"
          >
            <!--            <template v-slot:headers="props">-->
            <!--              <tr>-->
            <!--                <th-->
            <!--                    v-for="header in props.headers"-->
            <!--                    :key="header.text"-->
            <!--                    :class="[-->
            <!--                                        header.sortable !== false ? 'column sortable' : '',-->
            <!--                                        pagination.descending ? 'desc' : 'asc',-->
            <!--                                        header.value === pagination.sortBy ? 'active' : '',-->
            <!--                                    ]"-->
            <!--                    @click="changeSort(header.value)"-->
            <!--                >-->
            <!--                  {{ header.text }}-->
            <!--                  <v-icon small v-if="header.sortable !== false"-->
            <!--                  >arrow_upward-->
            <!--                  </v-icon>-->
            <!--                </th>-->
            <!--              </tr>-->
            <!--            </template>-->
            <template slot="items" slot-scope="props">
              <td>
                <router-link :to="{name:'trainTrackingDetails', params:{number:props.item.number}, query:{date: filters.date} }">
                  {{ props.item.number }}
                </router-link>
              </td>
              <td v-if="props.item.latest_activity">
                {{ props.item.latest_activity.time | appDateTimeFormat }}
              </td>
              <td v-else>
                -
              </td>

              <td>
                {{ props.item.name }} ({{ props.item.speed }})
              </td>

              <td>
                {{ props.item.first_station_name }}
                to
                {{ props.item.last_station_name }}
              </td>

              <td>
                {{ props.item.line_name }}
              </td>

              <td>
                {{ props.item.journey_status }}
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>

      <v-snackbar
          :timeout="snack_bar.timeout"
          :color="snack_bar.color"
          :top="snack_bar.top"
          :bottom="snack_bar.bottom"
          :left="snack_bar.left"
          :right="snack_bar.right"
          v-model="snack_bar.show"
      >
        {{ snack_bar.message }}
        <v-btn dark flat @click.native="snack_bar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import moment from "moment";

export default {
  created() {
  },
  computed: {
    ...mapGetters({
      office_location: "get_office_location",
    }),
    updatingRecordCount() {
      return this.allSelected ? (this.total_items - this.unCheckedRows.length) : (this.checkedRows.length);
    }
  },
  watch: {
    pagination: {
      handler() {
        this.getList();
      },
    }

    // 'pagination.page': {
    //   handler() {
    //     this.getList();
    //   },
    // },
    // 'pagination.rowsPerPage': {
    //   handler() {
    //     this.getList();
    //   },
    // },
    // 'pagination.descending': {
    //   handler() {
    //     this.getList();
    //   },
    // },
    // search_number: {
    //     handler(newVal) {
    //         if (newVal != null && newVal.length > 3) {
    //             this.getNumberList(newVal);
    //         }
    //     },
    // },
    // "filters.number": {
    //     handler(value) {
    //         if (value == undefined) {
    //             this.filters.title = "";
    //             this.getList();
    //         }
    //     },
    // },
  },
  methods: {
    changeSort(header) {
      if (this.pagination.sortBy != header)
        this.pagination.sortBy = header
      else
        this.pagination.descending = !this.pagination.descending
    },
    getList: function () {
      this.loaders.train_list = true;
      if(this.filters.date == null) {
        this.filters.date = moment().format('YYYY-MM-DD')
      }
      this.pagination.filters = Object.assign({}, this.filters);
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/web/train-tracking`, {
            params: this.pagination,
            headers: this.headers,
          }).then((response) => {
        if (response.data.status == 1) {
          this.train_list = response.data.data.data;
          this.total_items = response.data.data.total;
        }
      }).catch((error) => {
        console.log(error);
        this.snack_bar.message = "Error Occurred";
        this.snack_bar.show;
      }).finally(() => {
        {
          this.loaders.train_list = false;
        }
      });

      this.is_loading = false;
    },
    applyFiltersOnLoad: function () {
      return new Promise((resolve) => {
        this.filters.number = this.$route.query.number;
        resolve()
      })
    },
    getLinesList() {
      this.loading.lines = true
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/lines`)
          .then((response) => {
            if (response.data.status == 1) {
              this.lines = response.data.data
            }
          })
          .finally(() => {
            this.loading.lines = false
          })
    },
    applyFilters() {
      this.getList()
    }
  },
  data: () => {
    return {
      filterDateMenu: false,
      checkedRows: [],
      unCheckedRows: [],
      allSelected: false,
      speeds: [{text: 'All', value: null}, {text: 'Slow', value: 'S'}, {text: 'Fast', value: 'F'}],
      train_statuses:[{text: 'Ongoing', value: 'journey_ongoing'}, {text: 'Completed', value: 'journey_completed'}, {text: 'Stopped', value: 'location_disabled'}],
      loading: {
        exceptionDays: false,
        lines: false,
        properties: false,
      },
      exceptionDays: [],
      lines: [],
      properties: [],
      trainNumber: null,
      storeDialog: false,
      massUpdateDialog: false,
      announcement_item: {},
      number_list: [],
      search_number: "",
      delete_model: false,
      is_selected_all: false,
      all_selected_items: [],
      selected: [],
      is_filtered: false,
      loader: false,
      filter_key_count: -1,
      pagination: { sortBy: "updated_at", descending: true, rowsPerPage: 10 },
      filters: {
        lines:[],
        number: '',
        date: null
      },
      filter_dialog_box: false,
      snack_bar: {
        show: false,
        message: "",
        timeout: 4000,
        top: true,
        right: true,
        bottom: false,
        left: false,
        color: "",
      },
      total_items: 0,
      headers: [
        {
          text: "Number",
          value: "number",
          align: "left",
          sortable: false,
        },
        {
          text: "Last Tracking Time",
          value: "local_train_live_locations_time",
          align: "left",
          sortable: true,
        },
        {
          text: "Name",
          value: "name",
          align: "left",
          sortable: false,
        },
        {
          text: "From / To",
          value: "first_stations.name",
          align: "left",
          sortable: false,
        },
        {
          text: "Line",
          value: "local_lines.name",
          sortable: false,
        },
        {
          text: "Status",
          value: "journey_status",
          sortable: false,
        }
      ],
      train_list: [],
      add_new_office_model: false,
      new_office: {
        name: "",
      },
      loaders: {
        train_list: false,
        new_office_submit_loader: false,
      },
      auth_user: {
        roles: [{}],
      },
      currentDate:'',
      minDate: ''
    };
  },
  mounted() {
    this.getLinesList()
    this.applyFiltersOnLoad();
    this.auth_user = this.$store.getters.get_user;
    this.currentDate = moment().format('YYYY-MM-DD');
    this.minDate = moment().subtract(2, "days").format('YYYY-MM-DD');
  },
}
;
</script>

